import * as React from "react";
import protectedRoute from "../../protectedRoute";
import Container from "@mui/material/Container";
import { CssMessageTypography } from "../../styles/styled";
import Box from "@mui/material/Box";

function ConfirmPassword() {
  return (
    <React.Fragment>
      <Container
        style={{
          height: "50vh",
          display: "flex",
          alignItems: "center",
          minWidth: "1200px",
        }}
      >
        <Box style={{ margin: "0 auto" }}>
          <CssMessageTypography variant="button" display="block" gutterBottom>
            パスワード変更が完了しました。
          </CssMessageTypography>
        </Box>
      </Container>
    </React.Fragment>
  );
}

export default protectedRoute(ConfirmPassword);
